'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _request = require('@shopify/theme-cart/request');

var _module = require('./mixins/module');

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartQuantityUpdate = function (_Module) {
  (0, _inherits3.default)(CartQuantityUpdate, _Module);

  function CartQuantityUpdate(el) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, CartQuantityUpdate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CartQuantityUpdate.__proto__ || (0, _getPrototypeOf2.default)(CartQuantityUpdate)).call(this, el));

    _this.els = {
      el: el,
      updateButton: _this.getContextElement('.' + _this.className + '_Update'),
      inputs: _this.getContextElements('.js-QuantityAdjuster_Input')
    };

    _this._loading = false;

    _this.els.updateButton.addEventListener('click', function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var values;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                _this.loading = true;
                values = _this.els.inputs.map(function (el) {
                  return el.value;
                });
                _context.next = 5;
                return (0, _request.cartUpdate)({
                  updates: values
                });

              case 5:

                window.location.reload();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass3.default)(CartQuantityUpdate, [{
    key: 'loading',
    get: function get() {
      return this._loading;
    },
    set: function set(val) {
      this._loading = val;

      this.els.updateButton.classList.toggle('crt-Products_Update-loading', val);
    }
  }]);
  return CartQuantityUpdate;
}(_module2.default);

exports.default = CartQuantityUpdate;